import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import { useEffect } from 'react'; // Asegúrate de importar esto
import './generalzone.css';  // Asegúrate de importar el archivo CSS

const GeneralZoneForm = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const showId = Number(id);

  const shows = useSelector((state) => state.shows);
  const show = shows.find((s) => s.id === showId);
  const user = useSelector((state) => state.user); // Obtener el usuario desde Redux
  const [zoneName, setZoneName] = useState('');
  const [date, setDate] = useState('');
  const [performance, setPerformance] = useState('');
  const [startTime, setStartTime] = useState('');
  const [endTime, setEndTime] = useState('');
  const [zones, setZones] = useState([
    { division: "General", price: "", space: "" }
  ]);;


  useEffect(() => {
    if (!user?.isAdmin) {
      Swal.fire({
        title: 'Acceso denegado',
        text: 'Este show todavía no está habilitado',
        icon: 'warning',
        confirmButtonText: 'Volver',
      }).then(() => {
        navigate('/'); // Redirige al home u otra página
      });
    }
  }, [user, navigate]);

  useEffect(() => {
  if (!show) return;

  const presentation = show.presentation?.[0];
  if (!presentation) return;

  setDate(presentation.date || '');
  setPerformance(presentation.performance || '');
  setStartTime(presentation.time?.start || '');
  setEndTime(presentation.time?.end || '');
}, [show]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!show) {
      Swal.fire({
        title: 'Error',
        text: 'No se encontró el show',
        icon: 'error'
      });
      return;
    }

    const locationData = zones.map(zone => ({
      division: zone.division,
      price: Number(zone.price),
      space: Number(zone.space)
    }));

    const data = {
      showId,
      zoneName: "FlorestaGeneral",
      updates: {
        presentation: {
          date,
          performance: Number(performance),
          time: { start: startTime, end: endTime }
        },
        location: locationData
      }
    };


    try {
      await axios.post('/zones/add/general', data);
      Swal.fire({
        title: 'Zona creada con éxito',
        icon: 'success',
        confirmButtonText: 'OK',
        customClass: {
          popup: 'custom-popup-success',  // Clase personalizada para el popup de éxito
        }
      }).then();
    } catch (error) {
      Swal.fire({
        title: 'Error al crear la zona',
        text: error.response?.data?.message || error.message,
        icon: 'error'
      });
    }
  };

  if (!user?.isAdmin) {
    return null; // No renderiza nada mientras se espera la redirección
  }

  const addZone = () => {
    setZones([...zones, { division: "", price: "", space: "" }]);
  };

  const handleZoneChange = (index, field, value) => {
    const updated = [...zones];
    updated[index][field] = value;
    setZones(updated);
  };

  return (
    <div className="mt-[90px] min-h-screen flex items-center justify-center p-4 bg-[#12335F] backdrop-blur-md">
      <div className="w-full max-w-2xl container-bg backdrop-blur-md rounded-lg p-6 shadow-lg mt-20">
        <form className="flex flex-col gap-6" onSubmit={handleSubmit}>

          {/* Título */}
          <h2 className="text-2xl md:text-3xl font-bold text-center text-white">Editar/Zonas</h2>

          {/* Primera fila: Fecha y Presentación / Hora Inicio y Hora Fin */}
          <div className="flex flex-col md:flex-row gap-4">
            <div className="flex flex-col w-full md:w-1/2 gap-3">
              <label className="text-white font-semibold">Fecha de Presentación:
                <input
                  type="date"
                  value={date}
                  onChange={(e) => setDate(e.target.value)}
                  required
                  className="form-input p-2 rounded bg-[#608CC4] border border-white text-white focus:outline-none focus:ring-2 focus:ring-blue-400 w-full"
                />
              </label>
              <label className="text-white font-semibold">Presentación:
                <input
                  type="number"
                  value={performance}
                  onChange={(e) => setPerformance(e.target.value)}
                  required
                  className="form-input p-2 rounded bg-[#608CC4] border border-white text-white focus:outline-none focus:ring-2 focus:ring-blue-400 w-full"
                />
              </label>
            </div>
            <div className="flex flex-col w-full md:w-1/4 gap-3">
              <label className="text-white font-semibold">Hora de Inicio:
                <input
                  type="time"
                  value={startTime}
                  onChange={(e) => setStartTime(e.target.value)}
                  required
                  className="form-input p-2 rounded bg-[#608CC4] border border-white text-white focus:outline-none focus:ring-2 focus:ring-blue-400 w-full"
                />
              </label>
              <label className="text-white font-semibold">Hora de Fin:
                <input
                  type="time"
                  value={endTime}
                  onChange={(e) => setEndTime(e.target.value)}
                  required
                  className="form-input p-2 rounded bg-[#608CC4] border border-white text-white focus:outline-none focus:ring-2 focus:ring-blue-400 w-full"
                />
              </label>
            </div>
          </div>

          {zones.map((zone, index) => (
            <div key={index} className="border p-4 rounded flex flex-col md:flex-row gap-4">

              {/* Nombre */}
              <div className="flex flex-col w-full md:w-1/3">
                <label className="text-white font-semibold">División:</label>
                <input
                  type="text"
                  value={zone.division}
                  onChange={(e) =>
                    handleZoneChange(index, "division", e.target.value)
                  }
                  className="form-input p-2 rounded bg-[#608CC4] border border-white text-white w-full"
                />
              </div>

              {/* Precio */}
              <div className="flex flex-col w-full md:w-1/3">
                <label className="text-white font-semibold">Precio:</label>
                <input
                  type="number"
                  value={zone.price}
                  onChange={(e) =>
                    handleZoneChange(index, "price", e.target.value)
                  }
                  className="form-input p-2 rounded bg-[#608CC4] border border-white text-white w-full"
                />
              </div>

              {/* Capacidad */}
              <div className="flex flex-col w-full md:w-1/5">
                <label className="text-white font-semibold">Capacidad:</label>
                <input
                  type="number"
                  value={zone.space}
                  onChange={(e) =>
                    handleZoneChange(index, "space", e.target.value)
                  }
                  className="form-input p-2 rounded bg-[#608CC4] border border-white text-white w-full"
                />
              </div>

            </div>
          ))}

          {/* Botones */}
          <div className="flex flex-col md:flex-row gap-4 mt-4">
            <button type="submit" className="secondary text-white px-4 py-2 rounded transition-colors w-full md:w-auto">
              Guardar Zona
            </button>
            <button
              type="button"
              onClick={() => navigate('/')}
              className="secondary text-white px-4 py-2 rounded transition-colors w-full md:w-auto"
            >
              Cerrar
            </button>
            <button type="button" onClick={addZone}>
              + Agregar Zona
            </button>
          </div>

        </form>
      </div>
    </div>
  );

};

export default GeneralZoneForm;
